import { useState } from "react";
import Image1 from "../Assests//features/Untitled.png"
import Image2 from "../Assests/features/Untitled design (6).png"
import Image3 from "../Assests/features/Untitled design (7).png"
import Image4 from "../Assests/features/Untitled design (8).png"

const cards = [
  {
    id: "kayak-ai",
    titleNode: (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontWeight: 700, fontSize: 17, color: "#111" }}>BookinIndia.ai</span>
        <span style={{
          background: "#1a1a1a", color: "#fff", fontSize: 10,
          fontWeight: 700, borderRadius: 5, padding: "2px 6px", letterSpacing: 0.5
        }}>BETA</span>
      </div>
    ),
    sub: "Get travel questions answered",
    illustration: Image1, // Changed from "Image" to "illustration" for consistency
    isImage: true // Add this flag to know it's an image not SVG
  },
  {
    id: "explore",
    titleNode: <span style={{ fontWeight: 700, fontSize: 17, color: "#111" }}>Explore</span>,
    sub: "See destinations on your budget",
    illustration: Image2,
    isImage: true
  },
  {
    id: "trips",
    titleNode: <span style={{ fontWeight: 700, fontSize: 17, color: "#111" }}>Trips</span>,
    sub: "Keep all your plans in one place",
    illustration: Image3,
    isImage: true
  },
  {
    id: "priceAlert",
    titleNode: <span style={{ fontWeight: 700, fontSize: 17, color: "#111" }}>Price Alert</span>,
    sub: "Keep all your plans in one place",
    illustration: Image4,
    isImage: true
  },
];

export default function TravelProsSection() {
  const [hovered, setHovered] = useState(null);

  return (
    <div style={{
      background: "#f5f5f5",
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 20px",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      boxSizing: "border-box",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');
        .pros-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
          width: 100%;
          max-width: 1020px;
        }
        .pro-card {
          background: #fff;
          border-radius: 20px;
          border: 1px solid #ebebeb;
          padding: 22px 20px 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transition: box-shadow 0.2s, transform 0.2s;
          cursor: pointer;
          min-height: 260px;
        }
        .pro-card:hover {
          box-shadow: 0 8px 30px rgba(0,0,0,0.10);
          transform: translateY(-3px);
        }
        .pro-card .illus {
          margin-top: auto;
          height: 150px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }
        .pro-card .illus img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
        .section-title {
          font-size: 26px;
          font-weight: 800;
          color: #111;
          margin-bottom: 18px;
          letter-spacing: -0.5px;
        }
        @media (max-width: 860px) {
          .pros-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 520px) {
          .pros-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 10px !important;
          }
          .pro-card {
            padding: 16px 14px 0 14px !important;
            min-height: 200px !important;
            border-radius: 16px !important;
          }
          .pro-card .illus {
            height: 110px !important;
          }
          .section-title {
            font-size: 20px !important;
          }
        }
      `}</style>

      <div style={{ width: "100%", maxWidth: 1020 }}>
        <div className="section-title">For travel pros</div>
        <div className="pros-grid">
          {cards.map((card) => (
            <div
              key={card.id}
              className="pro-card"
              onMouseEnter={() => setHovered(card.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ marginBottom: 6 }}>{card.titleNode}</div>
              <div style={{
                fontSize: 13.5,
                color: "#6b7280",
                fontWeight: 400,
                lineHeight: 1.4,
              }}>
                {card.sub}
              </div>
              <div className="illus">
                {card.isImage ? (
                  <img src={card.illustration} alt={card.id} />
                ) : (
                  card.illustration
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}